import React, { useEffect, useState, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import styles from './NGSMainPage.module.css';
//--------------------------------- 이미지 파일 임포트
import smallDNABlack2 from '../../img/icon/DNA_image.png'

// RNA와 WES 컴포넌트
import RNAContent from './RNAContent';
import WESContent from './WESContent';

const TABS = {
    0: 'Lung',
    1: 'Gastric',
    2: 'Colon',
    3: 'Pancreas',
    4: 'Ovary',
    5: 'Bladder',
};

function NGSMainPage() {
    // const [selectedTab, setSelectedTab] = useState('default');
    const { NGSType, NGSSampleName } = useParams();
    const [selectedTab, setSelectedTab] = useState(NGSType === 'WES' ? 'WES' : 'default');
    const [selectedNGSType, setSelectedNGSType] = useState(NGSType === 'WES' ? 'WES' : 'RNA');

    const { t } = useTranslation();
    // const [selectedNGSType, setSelectedNGSType] = useState('RNA'); // RNA 기본 선택
    const [currentSampleCount, setCurrentSampleCount] = useState(0); // 백엔드에서 받아올 샘플 수




    // 페이지 로딩 시 현재 분석중인 샘플 수 백엔드 API 호출 (예: /api/getCurrentSampleCount)
    useEffect(() => {
        fetch('/api/getCurrentSampleCount')
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error, status = ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                if (data && data.count !== undefined) {
                    setCurrentSampleCount(data.count);
                }
            })
            .catch(error => console.error('샘플 수를 가져오지 못했습니다:', error));
    }, []);

    // 선택된 NGS 타입에 따라 컴포넌트 렌더링
    // 하위 컴포넌트에 검색어(NGSSampleName) 전달
    const renderNGSContent = () => {
        if (selectedNGSType === 'RNA') {
            // RNAContent에 initialSearch prop 전달
            return <RNAContent initialSearch={NGSSampleName} />;
        } else if (selectedNGSType === 'WES') {
            // WESContent에 initialSearch prop 전달
            return <WESContent initialSearch={NGSSampleName} />;
        }
    };

    return (
        <div className={styles.rightTab}>
            <div className={styles.topMenu}>
                <div className={styles.curOrganoid}>
                    <img src={smallDNABlack2} className={styles.draftListIcon} alt="icon" />
                    &nbsp;{t('NGS 분석')}
                </div>
                <div className={`${selectedTab === 'default' ? styles.topTabFront : styles.topTabBack}`}
                    onClick={() => {
                        setSelectedTab('default');
                        setSelectedNGSType('RNA');
                    }}
                >
                    RNA
                </div>
                <div />
                <div className={`${selectedTab === 'WES' ? styles.topTabFront : styles.topTabBack}`}
                    onClick={() => {
                        setSelectedTab('WES');
                        setSelectedNGSType('WES');
                    }}
                >
                    WES
                </div>
            </div>
            <div className={styles.rightTabBottomBox}>
                {/* 현재 분석중인 샘플 갯수를 표시 */}
                <div className={styles.analyzingCountDiv}>
                    {t('현재 분석중인 샘플 갯수')}: {currentSampleCount}
                </div>

                {/* 선택된 NGS 타입에 따라 다른 컴포넌트 렌더링 */}
                {/* <div className={styles.ngsContent}> */}
                {renderNGSContent()}
                {/* </div> */}
            </div>
        </div>
    );
}

export default NGSMainPage;
